import { Key, useCallback, useEffect, useState } from "react";
import { FontFa } from "../../../../components";
import { Table } from "antd";
import { TableHelpers } from "../../../../helper/TableHelper";
import { ColumnsType } from "antd/lib/table";
import { DocumentService } from "../../../../services/document/document.service";
import { useUser } from "../../../../hook";

const getIcon = (docType: string) => {
  switch (docType) {
    case "doc":
    case "docx":
      return <FontFa name="faFileWord" size="lg" color={"#0F4C81"} />;
    case "pptx":
    case "ppt":
      return <FontFa name="faFilePowerpoint" size="lg" color={"#D04423"} />;
    case "xlsx":
      return <FontFa name="faFileExcel" size="lg" color={"#1d6f42"} />;
    case "pdf":
      return <FontFa name="faFilePdf" size="lg" color={"#B0171F"} />;
    default:
      return <FontFa name="faFileCode" size="lg" />;
  }
};

export const PublishDocumentTableFormItem = ({ documentData, onChange, value }: any) => {
  const [validDocument, setValidDocument] = useState<any[]>([]);
  const { checkCurrentUser } = useUser();

  const getValidDocument = useCallback(async () => {
    const fileIds = documentData.map((e: { docWorkingId: number }) => e.docWorkingId);
    const documentsInfo = await DocumentService.getPublishDocumentByListId(fileIds);

    const validDocumentData = documentsInfo.data.filter((e: { fileAssignedTo: string }) => {
      const listUser = !e.fileAssignedTo ? [] : JSON.parse(e.fileAssignedTo);
      return listUser.findIndex((user: { email: string }) => checkCurrentUser(user.email)) > -1;
    });

    setValidDocument(validDocumentData);
  }, [checkCurrentUser, documentData]);

  const columns: ColumnsType<any> = [
    {
      title: "Tên tài liệu",
      dataIndex: "Title",
      render: (title: string, record: any) => (
        <div>
          {getIcon(record.type)} {title}
        </div>
      ),
      ...TableHelpers.searchInput({ dataIndex: "Title" }),
    },
    {
      title: "Loại tài liệu",
      dataIndex: "docType",
      width: 150,
    },
    {
      title: "Tình trạng",
      dataIndex: "docStatus",
      width: 150,
    },
  ];

  const handleSelectChange = (keys: Key[], records: any[]) => {
    onChange(records);
  };

  useEffect(() => {
    getValidDocument();
  }, [getValidDocument]);

  return (
    <Table
      rowSelection={{
        type: "checkbox",
        onChange: handleSelectChange,
      }}
      columns={columns}
      dataSource={validDocument}
      bordered
      rowKey="id"
      showHeader
    />
  );
};
